'use strict'

import polling from 'components/polling';
import './component.scss';

const MODAL_DIALOG_INPUT_ID = 'session-expiry-toggler',
      MODAL_DIALOG_INPUT = document.getElementById(MODAL_DIALOG_INPUT_ID),
      EXPIRY_SESSION_CONTAINER = document.querySelector('#session-expiry-container'),
      KEEP_ALIVE_BTN = document.querySelector('#session-expiry-container [data-keep-session-alive-btn]'),
      MIN = document.querySelector('.remaining-time--min'),
      SEC = document.querySelector('.remaining-time--sec'),
      ANNOUNCEMENT = document.querySelector('[data-session-expiry-announcement]');

let SECOND = 1000,
    MINUTE = 60,
    WARN_BEFORE_TIME,
    EXPIRES_IN_TIME,
    NOW,
    lastAnnouncedMinute,
    timer;

function init() {
    // On some pages expiry-session container isn't rendered
    if (!EXPIRY_SESSION_CONTAINER) {
        return;
    }

    setTimes();
    addEventListeners();
    setTimeout(checkSessionTimes, delay());
}

function addEventListeners() {
    MODAL_DIALOG_INPUT.addEventListener('light-box:open', initCountdown);
    KEEP_ALIVE_BTN.addEventListener('click', keepSessionAlive);
}

/**
 * Set times in ms for a certain point of time, if params are not passed they get default values
 * @param {*} warningTime   default is set on initial load
 * @param {*} expiresIn     default is set on initial load
 */
function setTimes(warningTime = EXPIRY_SESSION_CONTAINER.dataset.warnBefore, expiresIn = EXPIRY_SESSION_CONTAINER.dataset.expiresIn) {
    WARN_BEFORE_TIME = Number(warningTime);
    EXPIRES_IN_TIME = Number(expiresIn);
    NOW = Date.now();
}

function delay() {
    return WARN_BEFORE_TIME - NOW;
}

function initCountdown() {
    lastAnnouncedMinute = null;
    setRemainingTime();
    timer = setInterval(setRemainingTime, SECOND);

    function setRemainingTime() {
        const now = Date.now(),
              diff = (EXPIRES_IN_TIME - now) / SECOND;

        /** Handles the case where tab gets active after expiration time ellapsed
         *  Check is EXPIRES_IN_TIME in the past -> if true clear the interval and checkSessionTimes for last time before redirecting user to 'Session expired' page
         */
        if  (diff <= 0) {
            clearInterval(timer);
            timer = null;
            checkSessionTimes(true);
            return;
        }

        let mins = Math.floor(diff / MINUTE);
        let secs = Math.floor(diff % MINUTE);

        if (mins === 0 && secs === 0) {
            clearInterval(timer);
            timer = null;
            // There was no action, redirect user to 'Session expired' page
            checkSessionTimes(true);
        }

        MIN.innerText = mins;
        SEC.innerText = secs;

        if (mins !== lastAnnouncedMinute || secs === 30 || secs === 10) {
            ANNOUNCEMENT.innerText = `${ANNOUNCEMENT.dataset.timeRemaining} ${mins} ${ANNOUNCEMENT.dataset.minutes} ${secs} ${ANNOUNCEMENT.dataset.seconds}`;
            lastAnnouncedMinute = mins;
        }
    }
}

/**
 * Fetch session times so we can compare them to last recorded ones
 * @param {*} lastCheck - indicates it is the last check, before session expires. Default value is false, we pass true only when timer counter is 0
 */
function checkSessionTimes(lastCheck = false) {
    let url = EXPIRY_SESSION_CONTAINER.dataset.checkSessionUrl,
        sessionExpiredUrl = EXPIRY_SESSION_CONTAINER.dataset.sessionExpiredUrl;

    polling.pollOnce(url, response => {
        let data = JSON.parse(response),
            fetchedWarnBeforeTime = Number(data.warnBefore),
            fetchedExpiresInTime = Number(data.expiresIn);

        if (Math.floor(fetchedExpiresInTime / SECOND / MINUTE) > Math.floor(EXPIRES_IN_TIME / SECOND / MINUTE)) {
            // Session has been extended
            renewSession(fetchedWarnBeforeTime, fetchedExpiresInTime);
            document.dispatchEvent(new CustomEvent('modal-dialog:close', {detail: {id: MODAL_DIALOG_INPUT_ID}}));
        } else if (Math.floor(fetchedExpiresInTime / SECOND / MINUTE) == Math.floor(EXPIRES_IN_TIME / SECOND / MINUTE) && !lastCheck) {
            // No action detected - show modal dialog
            document.dispatchEvent(new CustomEvent('modal-dialog:open', {detail: {id: MODAL_DIALOG_INPUT_ID}}));
        } else if (Math.floor(fetchedExpiresInTime / SECOND / MINUTE) == Math.floor(EXPIRES_IN_TIME / SECOND / MINUTE) && lastCheck) {
            // Time is out - No action whatsoever
            // redirectUser to session expired page
            location.href = sessionExpiredUrl;
        }
    })
}

function keepSessionAlive(event) {
    event.preventDefault();

    let url = EXPIRY_SESSION_CONTAINER.dataset.renewSessionUrl;

    polling.pollOnce(url, response => {
        if (response) {
            let data = JSON.parse(response),
                expiresIn = Number(data.expiresIn),
                warnBefore = Number(data.warnBefore);

            clearInterval(timer);
            timer = null;
            renewSession(warnBefore, expiresIn);
            document.dispatchEvent(new CustomEvent('modal-dialog:close', {detail: {id: MODAL_DIALOG_INPUT_ID}}));
        } else {
            console.error('Something went wrong')
        }
    })
}

function renewSession(warningTime, expirationTime) {
    setTimes(warningTime, expirationTime);
    setTimeout(checkSessionTimes, delay());
}

window.addEventListener('DOMContentLoaded', init);